/**
 * @generated SignedSource<<2ede29974779d93e4e96b064a9d09bf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_ToolDataQuery$variables = {
  modelId: string;
  pricingFirst: number;
  productId: number;
  skipAI: boolean;
  skipAreaBackground: boolean;
  skipBulkVariations: boolean;
  skipCollage: boolean;
  skipExtensionFields: boolean;
  skipExtraOptions: boolean;
  skipImages: boolean;
  skipMoq: boolean;
  skipPlacement: boolean;
  skipPresetConfigurations: boolean;
  skipPricing: boolean;
  skipPrintingMethods: boolean;
  skipProfanity: boolean;
  skipQuote: boolean;
  skipShapes: boolean;
  skipTemplates: boolean;
};
export type productSidePanelContent_ToolDataQuery$data = {
  readonly additionalAttributesByProduct?: {
    readonly additionalAttributeID: number;
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly aiProductStagingRulesByProduct?: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly aiProductStagingRulesCount?: number;
  readonly aiVirtualModelRulesByProduct?: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly aiVirtualModelRulesCount?: number;
  readonly areaBackgroundRulesByProduct?: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly areaBackgroundRulesCount?: number;
  readonly designTemplates?: ReadonlyArray<{
    readonly designTemplateId: number;
    readonly name: string;
    readonly previewUrl: string;
  }>;
  readonly designWithAISetting?: {
    readonly settingsID: number;
  } | null;
  readonly extensionFields?: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly gridRulesByProduct?: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null;
  } | null> | null;
  readonly gridRulesCount?: number;
  readonly hasShapes?: boolean;
  readonly imageGeneration?: {
    readonly id: string;
  } | null;
  readonly imageMacroCategories?: ReadonlyArray<{
    readonly hasImages: boolean;
  }>;
  readonly moqRulesCount?: number;
  readonly myAdditionalAttributes?: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly placementsOutput?: ReadonlyArray<{
    readonly id: string;
    readonly isEnabled: boolean;
    readonly name: string;
    readonly placementOutputID: number;
  }>;
  readonly presetConfigurationsByProduct?: ReadonlyArray<{
    readonly compositionID: number;
    readonly id: string;
    readonly name: string | null;
    readonly previewImageUrl: string | null;
  }>;
  readonly pricings?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
      };
    }> | null;
  } | null;
  readonly pricingsDetailed?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly pricingID: number;
        readonly pricingName: string;
      };
    }> | null;
  } | null;
  readonly printTypes?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly printTypeID: number;
      };
    }> | null;
  } | null;
  readonly productMultipleVariantsRule?: {
    readonly attributeCodes: ReadonlyArray<string>;
    readonly bulkAsNameAndNumberEnabled: boolean;
    readonly enableImportCSV: boolean;
    readonly nameAndNumberEnabled: boolean;
    readonly options: string | null;
    readonly skipOptionForNameAndNumber: boolean;
  };
  readonly profanityFilterRulesCount?: number;
  readonly profanityFilterRulesForProduct?: {
    readonly printTypeRules: ReadonlyArray<{
      readonly key: number;
      readonly value: {
        readonly ruleID: number;
        readonly ruleName: string;
      } | null;
    }>;
    readonly productRule: {
      readonly ruleID: number;
      readonly ruleName: string;
    } | null;
  } | null;
  readonly quoteRulesCount?: number;
  readonly shapesAssignments?: {
    readonly printTypesIDs: ReadonlyArray<string>;
    readonly productsIDs: ReadonlyArray<string>;
  };
  readonly shapesAssignmentsForProduct?: {
    readonly forProduct: boolean | null;
    readonly printTypesIDs: ReadonlyArray<number>;
  };
  readonly shapesCount?: number;
};
export type productSidePanelContent_ToolDataQuery = {
  response: productSidePanelContent_ToolDataQuery$data;
  variables: productSidePanelContent_ToolDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pricingFirst"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAI"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAreaBackground"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipBulkVariations"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipCollage"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipExtensionFields"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipExtraOptions"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipImages"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipMoq"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPlacement"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPresetConfigurations"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPricing"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipPrintingMethods"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProfanity"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipQuote"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipShapes"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipTemplates"
},
v19 = [
  {
    "kind": "Variable",
    "name": "productId",
    "variableName": "productId"
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "designTemplateId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewUrl",
  "storageKey": null
},
v23 = [
  {
    "kind": "Variable",
    "name": "productID",
    "variableName": "modelId"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v25 = {
  "condition": "skipPresetConfigurations",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v23/*: any*/),
      "concreteType": "Composition",
      "kind": "LinkedField",
      "name": "presetConfigurationsByProduct",
      "plural": true,
      "selections": [
        (v24/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "compositionID",
          "storageKey": null
        },
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previewImageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v26 = {
  "kind": "Variable",
  "name": "productID",
  "variableName": "productId"
},
v27 = [
  (v26/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printTypesIDs",
  "storageKey": null
},
v29 = {
  "condition": "skipShapes",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v27/*: any*/),
      "concreteType": "ShapesAssignmentsForProduct",
      "kind": "LinkedField",
      "name": "shapesAssignmentsForProduct",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forProduct",
          "storageKey": null
        },
        (v28/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShapesAssignments",
      "kind": "LinkedField",
      "name": "shapesAssignments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productsIDs",
          "storageKey": null
        },
        (v28/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasShapes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shapesCount",
      "storageKey": null
    }
  ]
},
v30 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PricingGroup",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v24/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingID",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v32 = {
  "condition": "skipPricing",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "pricingFirst"
        },
        (v26/*: any*/)
      ],
      "concreteType": "PricingsDetailedConnection",
      "kind": "LinkedField",
      "name": "pricingsDetailed",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingsDetailedEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v30/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v31/*: any*/),
      "concreteType": "PricingsConnection",
      "kind": "LinkedField",
      "name": "pricings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PricingsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v30/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "pricings(first:200)"
    }
  ]
},
v33 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ruleID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ruleName",
    "storageKey": null
  }
],
v34 = {
  "condition": "skipProfanity",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v27/*: any*/),
      "concreteType": "ProfanityFilterAssignmentsForProduct",
      "kind": "LinkedField",
      "name": "profanityFilterRulesForProduct",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfanityFilterRuleRef",
          "kind": "LinkedField",
          "name": "productRule",
          "plural": false,
          "selections": (v33/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfanityFilterPrintTypeRuleRef",
          "kind": "LinkedField",
          "name": "printTypeRules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfanityFilterRuleRef",
              "kind": "LinkedField",
              "name": "value",
              "plural": false,
              "selections": (v33/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profanityFilterRulesCount",
      "storageKey": null
    }
  ]
},
v35 = [
  (v24/*: any*/),
  (v21/*: any*/)
],
v36 = {
  "alias": null,
  "args": (v27/*: any*/),
  "concreteType": "AIProductStagingRuleOutput",
  "kind": "LinkedField",
  "name": "aiProductStagingRulesByProduct",
  "plural": true,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": (v27/*: any*/),
  "concreteType": "AIVirtualModelRuleOutput",
  "kind": "LinkedField",
  "name": "aiVirtualModelRulesByProduct",
  "plural": true,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v38 = [
  (v24/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageGenerationDTO",
  "kind": "LinkedField",
  "name": "imageGeneration",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "settingsID",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiProductStagingRulesCount",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiVirtualModelRulesCount",
  "storageKey": null
},
v43 = {
  "condition": "skipCollage",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v27/*: any*/),
      "concreteType": "GridRule",
      "kind": "LinkedField",
      "name": "gridRulesByProduct",
      "plural": true,
      "selections": (v35/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gridRulesCount",
      "storageKey": null
    }
  ]
},
v44 = {
  "condition": "skipAreaBackground",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v27/*: any*/),
      "concreteType": "AreaBackgroundRuleTool",
      "kind": "LinkedField",
      "name": "areaBackgroundRulesByProduct",
      "plural": true,
      "selections": (v35/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "areaBackgroundRulesCount",
      "storageKey": null
    }
  ]
},
v45 = {
  "condition": "skipExtraOptions",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v23/*: any*/),
      "concreteType": "AdditionalAttribute",
      "kind": "LinkedField",
      "name": "additionalAttributesByProduct",
      "plural": false,
      "selections": [
        (v24/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalAttributeID",
          "storageKey": null
        },
        (v21/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": 0
        }
      ],
      "concreteType": "AdditionalAttribute",
      "kind": "LinkedField",
      "name": "myAdditionalAttributes",
      "plural": true,
      "selections": (v38/*: any*/),
      "storageKey": "myAdditionalAttributes(status:0)"
    }
  ]
},
v46 = {
  "condition": "skipPrintingMethods",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": (v31/*: any*/),
      "concreteType": "PrintTypesConnection",
      "kind": "LinkedField",
      "name": "printTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PrintTypesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PrintType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v24/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "printTypeID",
                  "storageKey": null
                },
                (v21/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "printTypes(first:200)"
    }
  ]
},
v47 = {
  "condition": "skipPlacement",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "modelId"
        }
      ],
      "concreteType": "PlacementOutput",
      "kind": "LinkedField",
      "name": "placementsOutput",
      "plural": true,
      "selections": [
        (v24/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "placementOutputID",
          "storageKey": null
        },
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v48 = {
  "condition": "skipBulkVariations",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "productId",
          "variableName": "modelId"
        }
      ],
      "concreteType": "ProductMultipleVariantsRule",
      "kind": "LinkedField",
      "name": "productMultipleVariantsRule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attributeCodes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameAndNumberEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "skipOptionForNameAndNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bulkAsNameAndNumberEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableImportCSV",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "options",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v49 = {
  "condition": "skipMoq",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "moqRulesCount",
      "storageKey": null
    }
  ]
},
v50 = {
  "condition": "skipQuote",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quoteRulesCount",
      "storageKey": null
    }
  ]
},
v51 = [
  {
    "kind": "Literal",
    "name": "onlybackground",
    "value": false
  }
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v53 = {
  "condition": "skipExtensionFields",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExtensionField",
      "kind": "LinkedField",
      "name": "extensionFields",
      "plural": true,
      "selections": (v35/*: any*/),
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ToolDataQuery",
    "selections": [
      {
        "condition": "skipTemplates",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v19/*: any*/),
            "concreteType": "DesignTemplate",
            "kind": "LinkedField",
            "name": "designTemplates",
            "plural": true,
            "selections": [
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v25/*: any*/),
      (v29/*: any*/),
      (v32/*: any*/),
      (v34/*: any*/),
      {
        "condition": "skipAI",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v36/*: any*/),
          (v37/*: any*/),
          (v39/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DesignWithAISettingDTO",
            "kind": "LinkedField",
            "name": "designWithAISetting",
            "plural": false,
            "selections": [
              (v40/*: any*/)
            ],
            "storageKey": null
          },
          (v41/*: any*/),
          (v42/*: any*/)
        ]
      },
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      {
        "condition": "skipImages",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v51/*: any*/),
            "concreteType": "ImageMacroCategory",
            "kind": "LinkedField",
            "name": "imageMacroCategories",
            "plural": true,
            "selections": [
              (v52/*: any*/)
            ],
            "storageKey": "imageMacroCategories(onlybackground:false)"
          }
        ]
      },
      (v53/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v18/*: any*/),
      (v12/*: any*/),
      (v17/*: any*/),
      (v13/*: any*/),
      (v15/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v14/*: any*/),
      (v11/*: any*/),
      (v5/*: any*/),
      (v10/*: any*/),
      (v16/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_ToolDataQuery",
    "selections": [
      {
        "condition": "skipTemplates",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v19/*: any*/),
            "concreteType": "DesignTemplate",
            "kind": "LinkedField",
            "name": "designTemplates",
            "plural": true,
            "selections": [
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v25/*: any*/),
      (v29/*: any*/),
      (v32/*: any*/),
      (v34/*: any*/),
      {
        "condition": "skipAI",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v36/*: any*/),
          (v37/*: any*/),
          (v39/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DesignWithAISettingDTO",
            "kind": "LinkedField",
            "name": "designWithAISetting",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          (v41/*: any*/),
          (v42/*: any*/)
        ]
      },
      (v43/*: any*/),
      (v44/*: any*/),
      (v45/*: any*/),
      (v46/*: any*/),
      (v47/*: any*/),
      (v48/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      {
        "condition": "skipImages",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v51/*: any*/),
            "concreteType": "ImageMacroCategory",
            "kind": "LinkedField",
            "name": "imageMacroCategories",
            "plural": true,
            "selections": [
              (v52/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": "imageMacroCategories(onlybackground:false)"
          }
        ]
      },
      (v53/*: any*/)
    ]
  },
  "params": {
    "cacheID": "48f61c9f985e31ef00c72b19f9e537e4",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ToolDataQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ToolDataQuery(\n  $productId: Long!\n  $modelId: ID!\n  $pricingFirst: Int!\n  $skipTemplates: Boolean!\n  $skipPresetConfigurations: Boolean!\n  $skipShapes: Boolean!\n  $skipPricing: Boolean!\n  $skipProfanity: Boolean!\n  $skipAI: Boolean!\n  $skipCollage: Boolean!\n  $skipAreaBackground: Boolean!\n  $skipExtraOptions: Boolean!\n  $skipPrintingMethods: Boolean!\n  $skipPlacement: Boolean!\n  $skipBulkVariations: Boolean!\n  $skipMoq: Boolean!\n  $skipQuote: Boolean!\n  $skipImages: Boolean!\n  $skipExtensionFields: Boolean!\n) {\n  designTemplates(productId: $productId) @skip(if: $skipTemplates) {\n    designTemplateId\n    name\n    previewUrl\n    id\n  }\n  presetConfigurationsByProduct(productID: $modelId) @skip(if: $skipPresetConfigurations) {\n    id\n    compositionID\n    name\n    previewImageUrl\n  }\n  shapesAssignmentsForProduct(productID: $productId) @skip(if: $skipShapes) {\n    forProduct\n    printTypesIDs\n  }\n  shapesAssignments @skip(if: $skipShapes) {\n    productsIDs\n    printTypesIDs\n  }\n  hasShapes @skip(if: $skipShapes)\n  shapesCount @skip(if: $skipShapes)\n  pricingsDetailed(productID: $productId, first: $pricingFirst) @skip(if: $skipPricing) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n      }\n    }\n  }\n  pricings(first: 200) @skip(if: $skipPricing) {\n    edges {\n      node {\n        id\n        pricingName\n        pricingID\n      }\n    }\n  }\n  profanityFilterRulesForProduct(productID: $productId) @skip(if: $skipProfanity) {\n    productRule {\n      ruleID\n      ruleName\n    }\n    printTypeRules {\n      key\n      value {\n        ruleID\n        ruleName\n      }\n    }\n  }\n  profanityFilterRulesCount @skip(if: $skipProfanity)\n  aiProductStagingRulesByProduct(productID: $productId) @skip(if: $skipAI) {\n    id\n    name\n  }\n  aiVirtualModelRulesByProduct(productID: $productId) @skip(if: $skipAI) {\n    id\n    name\n  }\n  imageGeneration @skip(if: $skipAI) {\n    id\n  }\n  designWithAISetting @skip(if: $skipAI) {\n    settingsID\n    id\n  }\n  aiProductStagingRulesCount @skip(if: $skipAI)\n  aiVirtualModelRulesCount @skip(if: $skipAI)\n  gridRulesByProduct(productID: $productId) @skip(if: $skipCollage) {\n    id\n    name\n  }\n  gridRulesCount @skip(if: $skipCollage)\n  areaBackgroundRulesByProduct(productID: $productId) @skip(if: $skipAreaBackground) {\n    id\n    name\n  }\n  areaBackgroundRulesCount @skip(if: $skipAreaBackground)\n  additionalAttributesByProduct(productID: $modelId) @skip(if: $skipExtraOptions) {\n    id\n    additionalAttributeID\n    name\n  }\n  myAdditionalAttributes(status: 0) @skip(if: $skipExtraOptions) {\n    id\n  }\n  printTypes(first: 200) @skip(if: $skipPrintingMethods) {\n    edges {\n      node {\n        id\n        printTypeID\n        name\n      }\n    }\n  }\n  placementsOutput(id: $modelId) @skip(if: $skipPlacement) {\n    id\n    placementOutputID\n    name\n    isEnabled\n  }\n  productMultipleVariantsRule(productId: $modelId) @skip(if: $skipBulkVariations) {\n    attributeCodes\n    nameAndNumberEnabled\n    skipOptionForNameAndNumber\n    bulkAsNameAndNumberEnabled\n    enableImportCSV\n    options\n  }\n  moqRulesCount @skip(if: $skipMoq)\n  quoteRulesCount @skip(if: $skipQuote)\n  imageMacroCategories(onlybackground: false) @skip(if: $skipImages) {\n    hasImages\n    id\n  }\n  extensionFields @skip(if: $skipExtensionFields) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a5abeea405490f9114c185f1f0ae80f";

export default node;
